import axios from "axios";

const baseURLs = {
  DISHA: "https://backend.shire.uplguru.com/", 

};

const createInstance = (baseURLKey) => {
  const baseURL = baseURLs[baseURLKey];
  if (!baseURL) {
    throw new Error(`Base URL key ${baseURLKey} not found in baseURLs.`);
  }

  return axios.create({
    baseURL,
  });
};

export default createInstance;